// extracted by mini-css-extract-plugin
export default {"fixedButtonsContainer":"FixedButtons_fixedButtonsContainer__uGj6P","scrollTopButton":"FixedButtons_scrollTopButton__ZQ3vV","writeButton":"FixedButtons_writeButton__nPv7R"};